import styled from "styled-components";
import theme from "../../../styles/theme";

import { useEffect } from 'react';
import { useLocation, useSearchParams, useNavigate } from 'react-router-dom';
import { useGetStaticItemSum } from "../../../interface/item";
import { useState } from 'react';
import { NumericFormatCustom } from "../dashboard/common";
import CommonDataGrid from "../../common/CommonDataGrid";
import { useGetCategoryList } from "../../../interface/common";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import ChartStaticInoutItem from "../dashboard/ChartStaticInoutItem";
import { useGetInoutStatic } from "../../../interface/inout";
import { IOT_TP } from "../../common/constants";

const MainWrap = styled.div`
    padding: 0.25rem 1.5rem; 
    h3 {
        font-size: ${theme.fontSize.base};
        font-weight: 600;
        margin: 0;
        color: ${theme.color.black};
    }
`;

const staticInoutColumn = [
    { field: 'iot_nm', headerName: '조사명', width:300},
    { field: 'cnm', headerName: '업체명', width:200},
    { field: 'is_ing', headerName: '조사상태', width:80},
    { field: 'work_nm', headerName: '담당자', width:120},
    { field: 'cnt_out', headerName: '반출', width:80},
    // { field: 'cnt_out_rel', headerName: '총 반출 연계자산', width:110},
    { field: 'cnt_in', headerName: '반입', width:80},
    // { field: 'cnt_in_rel', headerName: '총 반입 연계자산', width:110},
    { field: 'cnt_in_n', headerName: '정상', width:80},
    { field: 'cnt_in_d', headerName: '미사용/반납', width:80},
    { field: 'cnt_in_e', headerName: '고장/장애', width:80},
    { field: 'cnt_in_b', headerName: '파손', width:80},
    { field: 'cnt_in_x', headerName: '분실/도난', width:80},
    { field: 'cnt_in_z', headerName: '기타', width:80},
    { field: 'descr', headerName: '비고', width:120},
    // { field: 'chart', headerName: '반입현황', flex:20, minWidth:250, renderCell: ChartStaticInoutItem},
]

const StaticInout = () => {

    const navigate = useNavigate();

    const [searchParams] = useSearchParams();

    const [cid, setCid] = useState(searchParams.get('cid'));

    const [staticInoutList , setStaticInoutList] = useState([]);
    const [pCatelist, setPCateList] = useState([]);

    const {data: staticInout, isLoading: staticInoutLoading} = useGetInoutStatic({iot_tp:IOT_TP.SEARCH});

    useEffect(()=>{
        if(staticInout){
            setStaticInoutList(staticInout.map((item,index)=>({...item,is_ing:item.is_ing===1?'진행중':'완료',chart:[item],id:index})))
        }
    },[staticInout])

    const handleRowClick = (param, event) =>{
        navigate('/admin/inout/'+param.row.sno+'/inoutDetail')
    }

    return (
        <MainWrap>
            <h3>조사설치 현황</h3>
            <div style={{height:'8px'}} />
            <div style={{height:'85vh'}}>
            <CommonDataGrid
                    isLoading={staticInoutLoading}
                    list={staticInoutList}
                    columns={staticInoutColumn}
                    onRowClick={handleRowClick}
                    showCount={staticInoutList.length}
                />
            </div>
        </MainWrap>
    )

}

export default StaticInout;